import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { TopNav } from './TopNav';
import { LeftRail } from './LeftRail';
import { RightRail } from './RightRail';
import { Footer } from './Footer';
import { GlobalFloatingFilter } from './GlobalFloatingFilter';
import { auth } from '../firebase';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, theme, toggleTheme } = useApp();
  const [isLeftRailOpen, setIsLeftRailOpen] = useState(false);

  const isTestPage = location.pathname.includes('/test/') && 
    (location.pathname.includes('/start') || location.pathname.includes('/results') || location.pathname.includes('/detailed-results'));
  
  const isAuthPage = ['/signin', '/signup'].includes(location.pathname);
  const isSpecialPage = ['/robots.txt', '/sitemap.xml'].includes(location.pathname);
  
  const showLayout = !isTestPage && !isAuthPage && !isSpecialPage;
  const showMenuButton = showLayout;

  const handleSignOut = () => {
    auth.signOut();
    navigate('/');
  };

  const handleSelectExam = (examId: string) => {
    navigate(`/exam/${examId}`);
  };

  const handleNavigateToHome = () => {
    navigate('/');
  };

  const handleNavigateToDashboard = () => {
    navigate('/dashboard');
  };

  if (!showLayout) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-brand-bg text-brand-text-primary flex flex-col layout-transition">
      <TopNav 
        user={user}
        isLeftRailOpen={isLeftRailOpen} 
        onMenuToggle={() => setIsLeftRailOpen(!isLeftRailOpen)}
        showMenuButton={showMenuButton}
        onSignOut={handleSignOut}
        onNavigateToSignIn={() => navigate('/signin')}
        onNavigateToSignUp={() => navigate('/signup')}
        onNavigateToHome={handleNavigateToHome}
        onNavigateToDashboard={handleNavigateToDashboard}
        onNavigateToProfile={() => navigate('/profile')}
        theme={theme}
        onThemeToggle={toggleTheme}
      />
      
      <div className="flex flex-1 overflow-hidden">
        <LeftRail
          isOpen={isLeftRailOpen}
          activeExamId="jee-main"
          onSelectExam={handleSelectExam}
          onNavigateToHome={handleNavigateToHome}
        />
        
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 transition-all duration-300">
          <div className="max-w-7xl mx-auto page-transition-enter page-transition-enter-active">
            {children}
          </div>
        </main>
        
        <RightRail user={user} />
      </div>
      
      <Footer onNavigate={(page) => navigate(`/${page}`)} />
      <GlobalFloatingFilter />
    </div>
  );
};